import Repository from '../Repository';

const url = '/video/series';

export default {
    getSeriesForSidebar() {
        return Repository.get(`${url}/sidebar`);
    },

    getPaginated(page = 1) {
        return Repository.get(`${url}?page=${page}`)
    },

    getSeries(slug) {
        return Repository.get(`${url}/${slug}`);
    },

    getMyCoachSeries() {
        return Repository.get(`${url}/my-coach`);
    }
}
